import React from "react";

import { ReactComponent as Spinner } from "../assets/icons/loading-spinner.svg";
import style from "../assets/scss/components/loading-spinner.module.scss";

export default function LoadingSpinner() {
  return <Spinner className={style["spinner"]} />;
}
